<template>
	<main class="new-company-profile">
		<section class="new-company-profile__intro">
			<div class="new-company-profile__inner new-layout-container">
				<div class="new-company-profile__accent"></div>
				<h1>{{content.title}}</h1>

				<div class="new-company-profile__intro-copy">
					<p>{{content.introduction}}</p>

					<div class="new-company-profile__intro-block">
						<p>{{content.segmentsLabel}}</p>
						<ul>
							<li v-for="segment in content.segments" :key="segment">{{segment}}</li>
						</ul>
					</div>

					<p>{{content.operations}}</p>

					<p>{{content.vision}}</p>

					<h2>{{content.mission.title}}</h2>
					<p>{{content.mission.text}}</p>

					<h2>{{content.clients.title}}</h2>
					<p>{{content.clients.text}}</p>
				</div>
			</div>
		</section>

		<section class="new-company-profile__differentials">
			<div class="new-company-profile__inner new-layout-container">
				<div class="new-company-profile__accent"></div>
				<h2 class="new-company-profile__section-title">{{content.differentials.title}}</h2>

				<div class="new-company-profile__feature-grid">
					<article
						v-for="(feature, index) in content.differentials.items"
						:key="feature.title"
						class="new-company-profile__feature"
					>
						<img :src="featureIcons[index]" alt="" aria-hidden="true">
						<h3>{{feature.title}}</h3>
						<p>{{feature.text}}</p>
					</article>
				</div>
			</div>
		</section>

		<section class="new-company-profile__structure">
			<div class="new-company-profile__inner new-layout-container">
				<div class="new-company-profile__accent"></div>
				<h2 class="new-company-profile__structure-title">{{content.structure.title}}</h2>

				<div class="new-company-profile__structure-copy">
					<p v-for="paragraph in content.structure.paragraphs" :key="paragraph">{{paragraph}}</p>
				</div>
			</div>
		</section>
	</main>
</template>

<script>
import { translate } from '../../assets/translations';

const FEATURE_ICONS = [
	'experience-and-expertise',
	'local-knowledge',
	'innovative-products',
	'cutting-edge-technology',
	'solid-management-and-finance',
	'social-environmental-responsibility',
].map(name => `/static/buttons/new/company-profile/${name}.png`);

export default {
	data() {
		return {
			featureIcons: FEATURE_ICONS,
		};
	},
	computed: {
		content() {
			return translate(this.$store.state.language).staticPages.companyProfile;
		},
	},
};
</script>

<style scoped lang="scss">
.new-company-profile {
	background: #f5f5f5;
	color: #4c4b4b;
}

.new-company-profile__intro,
.new-company-profile__differentials {
	background: #ffffff;
}

.new-company-profile__intro {
	min-height: calc(100vh - 68px);
	padding: 86px 0 84px;
}

.new-company-profile__differentials {
	padding: 70px 0 84px;
}

.new-company-profile__structure {
	padding: 82px 0 122px;
}

.new-company-profile__inner {
	padding: 0;
}

.new-company-profile__accent {
	width: 44px;
	height: 0;
	margin-bottom: 28px;
	border-top: 4px solid #e89127;
}

.new-company-profile h1 {
	margin: 0 0 24px;
	color: #4c4b4b;
	font-size: 40px;
	font-weight: 700;
	line-height: 47px;
	letter-spacing: 0;
}

.new-company-profile__intro-copy {
	color: #4c4b4b;
	font-size: 22px;
	font-weight: 400;
	line-height: 35px;
}

.new-company-profile__intro-copy p {
	margin: 0 0 36px;
}

.new-company-profile__intro-block {
	margin: 0 0 36px;
}

.new-company-profile__intro-block p {
	margin-bottom: 0;
}

.new-company-profile__intro-copy p:last-child {
	margin-bottom: 0;
}

.new-company-profile__intro-copy ul {
	margin: 4px 0 0;
	padding-left: 34px;
	list-style-type: disc;
}

.new-company-profile__intro-copy h2 {
	margin: 30px 0 4px;
	color: #4c4b4b;
	font-size: 30px;
	font-weight: 700;
	line-height: 36px;
}

.new-company-profile__section-title,
.new-company-profile__structure-title {
	margin: 0;
	color: #4c4b4b;
	font-size: 26px;
	font-weight: 700;
	line-height: 32px;
	letter-spacing: 0;
}

.new-company-profile__feature-grid {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	gap: 74px 162px;
	margin-top: 42px;
}

.new-company-profile__feature {
	min-width: 0;
}

.new-company-profile__feature img {
	display: block;
	width: 100px;
	height: 100px;
	margin-bottom: 15px;
	object-fit: contain;
}

.new-company-profile__feature h3 {
	margin: 0 0 4px;
	color: #4c4b4b;
	font-size: 25px;
	font-weight: 700;
	line-height: 35px;
}

.new-company-profile__feature p,
.new-company-profile__structure-copy {
	color: #4c4b4b;
	font-size: 22px;
	font-weight: 400;
	line-height: 35px;
}

.new-company-profile__feature p {
	margin: 0;
}

.new-company-profile__structure-copy {
	margin-top: 52px;
}

.new-company-profile__structure-copy p {
	margin: 0 0 32px;
}

.new-company-profile__structure-copy p:last-child {
	margin-bottom: 0;
}

@media (max-width: 1100px) {
	.new-company-profile__feature-grid {
		gap: 56px 70px;
	}
}

@media (max-width: 820px) {
	.new-company-profile__intro {
		padding: 58px 0 72px;
	}

	.new-company-profile__differentials,
	.new-company-profile__structure {
		padding: 58px 0 72px;
	}

	.new-company-profile h1 {
		font-size: 34px;
		line-height: 40px;
	}

	.new-company-profile__intro-copy {
		font-size: 18px;
		line-height: 30px;
	}

	.new-company-profile__feature-grid {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
}

@media (max-width: 560px) {
	.new-company-profile__feature-grid {
		grid-template-columns: 1fr;
		gap: 38px;
	}

	.new-company-profile__intro-copy {
		font-size: 16px;
		line-height: 27px;
	}

	.new-company-profile__intro-copy h2 {
		font-size: 24px;
		line-height: 30px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/company-profile/CompanyProfile.vue